<template>
  <div class="gallery_item">
    <template v-if="datas">
      <template v-if="datas.coverurl">
        <router-link :to="`/events/${datas.id}`" :key="datas.id">
          <div class="gallery_item_thumb">
            <img
              v-lazy="datas.coverurl"
              alt="gallery"
              class="custom-img"
            />
          </div>
        </router-link>
      </template>
      <div class="gallery_item_content">
        <router-link :to="`/events/${datas.id}`" :key="datas.id">
          <h4 class="title">
            {{ datas.fullname }}
          </h4>
          <div class="summary">{{ datas.summary }}</div>
        </router-link>
        <div class="meta-info">
          <!-- <el-tag type="warning">立项结果</el-tag>  -->
          <el-tag 
            type="primary" 
            class="cursor-pointer"
            @click="handleForm(datas)"
          >
            <span>立即报名</span>
          </el-tag>
          <span class="date">{{ formatTimestampToDate(datas.starttime) }}</span>
        </div>
      </div>
    </template>

    <template v-if="smalldatas">
      <template v-if="smalldatas.coverurl">
        <router-link :to="`/events/${smalldatas.id}`" :key="smalldatas.id">
          <div class="gallery_item_thumb big-thumb">
            <img
              v-lazy="smalldatas.coverurl"
              :key="smalldatas.id"
              :alt="smalldatas.fullname"
              class="custom-img"
            />
          </div>
        </router-link>
      </template>
      
      <div class="gallery_item_content small-content">
        <router-link :to="`/events/${smalldatas.id}`" :key="smalldatas.id">
          <h4 class="title">
            {{ smalldatas.fullname }}
          </h4>
          <div class="info-with-progress">
            <div class="info-details">
              <div class="info-item" v-if="!smalldatas.settings?.allowreg">
                <div class="summary">{{ smalldatas.summary }}</div>
              </div>
              <template v-else>
                <div class="info-item" v-if="!checkCuid && smalldatas?.manuscript">
                  <span class="info-label">课题名称：</span>
                  <span class="info-value">{{ smalldatas?.manuscript.title }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">报名截止时间：</span>
                  <span class="info-value">{{ formatTimestampToDate(smalldatas.starttime) }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">结项时间：</span>
                  <span class="info-value">{{ formatTimestampToDate(smalldatas.closetime) }}</span>
                </div>
                <template v-if="smalldatas?.manuscript && smalldatas?.manuscript?.status != null">
                  <div class="mt-2">
                    <el-tag size="small" v-if="status === 0">
                      <span v-if="ticketList.length > 0 && smalldatas?.manuscript?.orderpaystatus < 99 && smalldatas?.manuscript?.orderpaystatus !== 50">报名信息已提交，待付款</span>
                      <span v-else>报名信息已提交，待审核</span>
                    </el-tag>
                    <el-tag size="small" v-if="status === -90" type="danger">已拒绝</el-tag>
                    <el-tag size="small" v-else-if="status === 1" type="success">报名审核通过</el-tag>
                    <el-tag size="small" v-else-if="status === 2">二期材料已提交，待审核</el-tag>
                    <el-tag size="small" v-else-if="status === 3" type="success">二期材料审核通过</el-tag>
                    <el-tag size="small" v-else-if="status === 4">结项材料已提交，待审核</el-tag>
                    <el-tag size="small" v-else-if="status === 5" type="success">结项审核通过</el-tag>
                    <el-tag size="small" v-else-if="status === 100">已结项</el-tag>
                  </div>
                </template>
              </template>
            </div>
            
            <!-- 当type为课题中心时显示圆形进度条 -->

            <template v-if="smalldatas.settings?.allowreg && smalldatas.type === 20">
              <el-progress 
                v-if="smalldatas?.manuscript?.status == -90"
                type="circle" 
                :percentage="50" 
                status="exception"
                :width="80"
              ></el-progress>


            <el-progress 
              v-else
              type="circle" 
              :percentage="percentage" 
              class="progress-circle"
              :width="80"
            ></el-progress>

            </template>
          </div>
        </router-link>
        <div class="meta-info">
          <template v-if="smalldatas.settings.allowreg">
            <el-tag 
              :type="smalldatas.isParticipated ? 'warning' : 'primary'" 
              class="cursor-pointer"
              @click="handleForm(smalldatas)"
            >
            <span v-if="smalldatas.isParticipated && (!checkCuid || smalldatas?.manuscript?.cuid == userProfile.id)">查看报名</span>
              <span v-else>立即报名</span>
            </el-tag>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { formatTimestampToDate } from '@/utils/dateUtil'; 
import profileService from '@/utils/profileService';
import { getTicketList } from '@/api/event';
import { 
  getMeOrders
} from '@/api/user';

export default {
  props: {
    category: {
      type: Boolean,
    },
    trending: {
      type: Boolean,
    },
    sports: { type: Boolean, default: false },
    datas: {
      type: Object,
    },
    smalldatas: {
      type: Object,
    },
    checkCuid: {
      type: Boolean,
      default: false
    },
    counting: {
      type: Boolean,
    },
    countingtwo: {
      type: Boolean,
    },
    count: {
      type: Number,
    }
  },
  data() {
    return {
      ticketList: []
    }
  },
  async created() {
    this.eventid = this.smalldatas.id;
    this.getTickets(this.eventid);
    if (this.smalldatas?.manuscript?.orderpaystatus == null){
      //从订单中获取，赋值给orderpaystatus
      const meOrdersRes = await getMeOrders({
        filter: {
          validstatus: true,
          refid: this.smalldatas?.manuscript?.id,
          type: 4  // 4对应评审费订单
        }
      });
      //过滤meOrdersRes，只保留type为4的订单
      const filteredOrders = meOrdersRes.list.filter(order => order.refid === this.smalldatas?.manuscript?.id);
      if (filteredOrders.length > 0){
        const paystatus = filteredOrders[0].paystatus;
        // Add safety check before assignment
        if (this.smalldatas && this.smalldatas.manuscript) {
          this.smalldatas.manuscript.orderpaystatus = paystatus;
        }
      }
    }
  },
  computed: {
    userProfile() {
      return profileService.getProfile();
    },
    // 添加status计算属性
    status() {
      return this.smalldatas?.manuscript?.status;
    },
    percentage() {
      // 使用新添加的status计算属性
      const status = this.status;
      switch(status) {
        case -90:return 50;
        case 100:return 100;

        case 0:
          if(this.ticketList.length > 0 && this.smalldatas?.manuscript?.orderpaystatus !== 100){
            return 10;
          }else{
            return 20;
          }
        case 1:return 40;
        case 2:
        case 3:return 60;
        case 4:return 80;
        case 5:return 100;


        default:return 0;
      }
    }
  },

  methods: {
    formatTimestampToDate,
    handleForm(data) {
      if (!this.userProfile) {
        this.$message({
          message: '请先登录',
          type: 'warning',
        });
        return;
      }

      const id = data.id;
      const manuscriptid = data.manuscriptid;
      this.$router.push({ 
        name: 'EventForm', 
        params: { id },
        query: { 
          manuscriptid,
          // 当checkCuid为true时传递该参数
          ...(this.checkCuid ? { checkCuid: true } : {})
        }
      });
      window.scrollTo(0, 0);
    },
    async getTickets(eventid) {
      const res = await getTicketList(eventid);
      if (res.code === 200) {
        const currentTime = Math.floor(Date.now() / 1000);
        this.ticketList = res.list.filter(ticket => 
          ticket.status === 100 && 
          ticket.salestart < currentTime && 
          ticket.saleclose > currentTime
        );
      }
    }
  }
};
</script>

<style scoped>
.custom-img {
  /* 修改为最大宽度，允许在小屏幕自适应 */
  max-width: 240px;
  width: 100%;
  border-radius: 5px;
  height: auto;
  object-fit: cover;
  object-position: center;
}
.big-thumb img {
  max-width: 260px;
}

.title-count-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  margin: 0;
  flex-grow: 1;
}
.summary {
  width: 100%;
  line-height: 24px;
  font-size: 14px;
  margin: 15px 0 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  word-break: break-all;
  color: #7f7f7f;
  /* 添加最小高度确保始终占据两行空间 */
  min-height: 48px;
}
.date {
  color: #a9a9a9;
  font-size: 14px;
}
.count {
  margin-left: 10px; /* 可根据需要调整间距 */
}
.custom-hot-img {
  width: 80px;
  height: auto;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}
.custom-post-img {
  width: 80px;
  height: 70px;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}
.custom-sports-img {
  width: 100px;
  height: auto;
  object-fit: cover;
  object-position: center;
}
.gallery_item{
  min-height: 200px;
  height: auto;
  border-bottom: 1px solid #e1e7f2;
  padding: 20px 0;
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
  width: 100%;
  margin-bottom: 20px;
}
.gallery_item .big-thumb {
  margin-right: 40px;
}
/* 添加移动端媒体查询 */
@media (max-width: 768px) {
  .gallery_item {
    /* 移动端改为纵向排列 */
    flex-direction: column;
    padding: 15px;
    min-height: auto;
  }
  
  .gallery_item_thumb {
    /* 图片容器在移动端居中显示 */
    margin-bottom: 15px;
    width: 100%;
    /* 修改 max-width 为 100% 以让图片容器占满宽度 */
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  
  .custom-img {
    width: 100% !important;
    max-width: none !important;
    height: auto;
  }
  
  .gallery_item_content {
    width: 100%;
    padding: 0 5px;
  }
  
  .title {
    font-size: 16px;
    line-height: 1.4;
  }
  
  .summary {
    /* 移动端摘要行高和最小高度调整 */
    line-height: 20px;
    min-height: 40px;
    margin: 8px 0 15px;
    font-size: 13px;
  }
  
  .meta-info {
    /* 标签和日期区域调整 */
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .el-tag.el-tag--warning{
    /* 移动端标签样式优化 */
    /* margin-right: 10px; */
    /* padding: 0 10px; */
    font-size: 12px;
    /* height: 24px; */
    /* margin-bottom: 5px; */
  }
  
  .date {
    font-size: 12px;
  }
}
/* 新增信息详情样式 */
.info-with-progress {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.info-details {
  flex: 1;
  margin: 9px 0;
  line-height: 1.5;
}

.progress-circle {
  margin-top: 20px;
}
.info-item {
  display: flex;
  margin-bottom: 4px;
}

.info-label {
  font-weight: 500;
  color: #333;
  min-width: 100px;
}

.info-value {
  color: #666;
  flex: 1;
}

/* 添加图片占位容器样式 */
.gallery_item_thumb {
  /* 保持原有样式 */
  margin-bottom: 15px;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  /* 添加相对定位作为占位容器的定位基准 */
  position: relative;
  /* 设置固定宽高比 (例如 16:9) */
  padding-top: 56.25%; /* 16:9 比例 */
  overflow: hidden;
}

/* 图片样式调整 */
.custom-img {
  /* 修改为绝对定位，使其覆盖在占位容器上 */
  position: absolute;
  top: 0;
  left: 0;
  /* 添加Flex布局使内容区域垂直排列 */
  display: flex;
  flex-direction: column;
  height: 100%;
  /* 保持原有样式 */
  max-width: 240px;
  width: 100%;
  border-radius: 5px;
  height: 100%; /* 使用100%高度填充容器 */
  object-fit: cover;
  object-position: center;
}

::v-deep .gallery_item_content a {
  display: block;
  width: 100%;
}

/* 占位容器样式 */
.img-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5; /* 浅灰色占位背景 */
  border-radius: 5px;
}

/* 添加移动端布局调整 */
@media (max-width: 767px) {
  .gallery_item {
    display: block; /* 移动端将flex布局改为块级布局 */
  }
  
  .gallery_item_thumb {
    min-height: 180px; /* 确保图片容器有最小高度 */
  }
}

.gallery_item_content {
  /* 添加弹性布局属性，确保内容区域占满剩余空间 */
  flex: 1;
  min-width: 0; /* 允许内容区域在必要时收缩 */
}

.info-with-progress {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  /* 添加宽度设置，确保进度条区域正确排列 */
  width: 100%;
}

/* 修改meta-info样式，使其自动定位到底部 */
.small-content .meta-info {
  /* margin-top: auto;
  padding-top: 15px; */
}
</style>
